'use strict';
import $ from 'jquery';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export default class TestimonialsSlider {
    static init() {
        $('.module-testimonials-slider').each((index, el) => {
            new TestimonialsSlider($(el));
        });
    }

    constructor($el) {
        this.el = $el;
        if (this.el.find('.swiper-slide').length > 1) {
            const slider = this.el.find('.swiper');
            if (slider.length > 0) {
                const swiper = new Swiper('#' + slider.attr('id'), {
                    modules: [Navigation, Pagination],
                    navigation: {
                        prevEl: '.swiper-button-prev',
                        nextEl: '.swiper-button-next',
                        addIcons: false,
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    }
                });
            }
        }
    }
}